import script from "./attachmentListFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./attachmentListFilters.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__